export const COUNTERPARTIES_PATH = "/counterparties";
